import styled from 'styled-components';

import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NavLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 41px;
  border-radius: var(--border-radius8);
  background-color: var(--color-greyEC);
  margin-right: 6px;
  text-decoration: none;
  @media (hover) {
    &:hover {
      background: var(--color-greyF8);
    }
  }
  &:active {
    background: #bdbcbc;
  }
  &:focus {
    box-shadow: var(--shadow-focus);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1 auto;
  height: 41px;
  opacity: 0.88;
  background-color: var(--color-greyEC);
  border-radius: var(--border-radius8);
`;

export const LeftSide = styled.p`
  opacity: 0.88;
  font-size: var(--font-size18);
  line-height: 1.22;
  letter-spacing: 0.5px;
  color: var(--color-grey6A);
  padding-left: 13px;
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

export const Bold = styled(LeftSide)`
  font-weight: var(--font-weight600);
  padding-left: 0;
`;

export const Status = styled.p`
  opacity: 0.88;
  font-size: var(--font-size10);
  font-weight: var(--font-weight600);
  letter-spacing: 1.01px;
  color: ${({ $color }) => $color || '#676767'};
  padding: 0 20px;
`;
